function getColumnStyle(column) {
    const style = {};
    if (typeof column.flex !== 'undefined') {
        style.flex = column.flex === 'none' ? 'none' : `${column.flex} ${column.flex} 0`;
    }
    if (typeof column.width !== 'undefined') {
        style.width = `${column.width}px`;
    }
    return style;
}
const CELL_CLASS = 'cell';
const CELL_CLASS_MENU = 'cell__menu';

export { CELL_CLASS_MENU as C, CELL_CLASS as a, getColumnStyle as g };
